<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div>
      <div>
        <p class="navadno-besedilo">
          Za izbrano telefonsko številko lahko nastavite preusmeritve klicev. Izberete lahko eno ali več preusmeritev.
        </p>
      </div>
      <div v-loading="jePridobivanjePreusmeritevUMTS" style="padding-top: 30px">
        <el-form inline label-width="420px" :label-position="formaOrientacija">
          <div v-for="zapore in seznamPreusmeritev">
            <el-form-item :label=zapore.name class="krepko-zapore">
              <el-radio-group v-model="zapore.active" @change="updatePossibleRuleChanges(zapore)">
                <el-radio :label="false" class="odmik-radio" :disabled="zapore.disabled === true">
                  Neaktivno
                </el-radio>
                <el-radio :label="true" :disabled="zapore.disabled === true">
                  Aktivno
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="telefonska-stevilka" :label=zapore.numberText>
              <el-input class="velikost-input"
                        v-model="zapore.number"
                        v-show="zapore.number !== null && typeof zapore.number !== 'undefined'"
                        :disabled="zapore.active === false || zapore.disabled === true"
                        placeholder="Format: 38664100100"
                        type="phone"
                        v-bind:class="GetPhoneNumberClass(zapore)">
              </el-input>
            </el-form-item>
            <el-form-item
              class="odziv-krepko"
              label="Čas odziva"
              v-if="zapore.timeOptions !== undefined && zapore.timeOption !== null">
              <el-select placeholder="Izberite" size="large"
                         class="velikost-input odziv" v-model="zapore.time">
                <el-option
                    v-for="(obj, key) in zapore.timeOptions"
                    :label="obj"
                    :key="key"
                    :value="key">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="postavitev-gumb">
          <el-button type="primary" @click="NastaviPreusmeritve(seznamPreusmeritev)"
                     class="gumb-potrdi">
            SHRANI SPREMEMBE
          </el-button>
        </div>
        <div>
          <InfoOknoPreusmeritve/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Checkbox, Button, Select, Option, Input, Loading, Collapse, CollapseItem} from 'element-ui'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {PhoneNumberValidator} from 'src/assets/js/globalne_funkcije/GlobalnoTelefonija/PhoneNumberValidator.js'
import ClientAgent from '../../../../../../assets/js/clientAgent'
import InfoOknoPreusmeritve from './InfoOknoPreusmeritve.vue'

export default {
  name: 'PreusmeritevMobilnaTelefonija',
  mixins: [PrikazVsebine],
  data () {
    return {
      formaOrientacija: 'left',
      klicNaCakanju: '',
      casovnaIzbira: '',
      mejnaSirina: 1200,
      jePridobivanjePreusmeritevUMTS: false,
      clientAgent: null,
      seznamPreusmeritev: []
    }
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String,
    seznamCasovnihIzbir: Array,
    podatkiOSim: null
  },
  components: {
    InfoOknoPreusmeritve,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  created () {
    this.clientAgent = new ClientAgent()
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.GetPreusmeritve()
  },
  methods: {
    updatePossibleRuleChanges (changedElement) {
      for (let j = 0; j < this.seznamPreusmeritev.length; j++) {
        let checkElement = this.seznamPreusmeritev[j]
        if (changedElement.excludedIds.indexOf(checkElement.id) !== -1) {
          if (changedElement.active === true) {
            checkElement.active = false
            checkElement.disabled = true
          } else {
            checkElement.disabled = false
          }
        }
      }
      this.$forceUpdate()
    },
    async GetPreusmeritve () {
      try {
        if (this.podatkiOSim !== null && this.podatkiOSim.idSimKartica !== null) {
          this.response = await this.clientAgent.makeRequest(
            'prikljucek/telefonija/umts/sim/redirects',
            {
              idSimKartica: this.podatkiOSim.idSimKartica
            },
            'GET'
          )
          this.SetPreusmeritve(this.response)
        }
      } catch (e) {
        this.ErrPreusmeritve({message: 'Prišlo je do napake.'})
      }
    },
    SetPreusmeritve (podatki) {
      this.seznamPreusmeritev = podatki.redirects
      this.jePridobivanjePreusmeritevUMTS = false
    },
    ErrPreusmeritve (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.jePridobivanjePreusmeritevUMTS = false
    },
    async NastaviPreusmeritve (spremebaPreusmeritev) {
      let formValid = true
      spremebaPreusmeritev.forEach(sprememba => {
        if (sprememba.active === true &&
          typeof sprememba.number !== 'undefined' && sprememba.number !== null &&
          !PhoneNumberValidator.methods.ValidateSLOMobileNumber(sprememba.number) &&
          !PhoneNumberValidator.methods.ValidateSLOFixNumber(sprememba.number)) {
          formValid = false
          return false
        }
      })
      if (!formValid) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Vpisane številke preusmeritev niso veljavne.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      }
      this.jePridobivanjePreusmeritevUMTS = true
      let params = {
        idSimKartica: this.podatkiOSim.idSimKartica,
        redirects: JSON.stringify(spremebaPreusmeritev)
      }
      try {
        this.response = await this.clientAgent.makeRequest(
          'prikljucek/telefonija/umts/sim/redirects',
          params,
          'PATCH'
        )
        this.SetPreusmeritve(this.response)
      } catch (e) {
        this.ErrPreusmeritve({message: 'Prišlo je do napake.'})
      }
    },
    GetPhoneNumberClass (redirectElement) {
      if (redirectElement.active === true &&
          redirectElement.number !== null &&
          !PhoneNumberValidator.methods.ValidateSLOMobileNumber(redirectElement.number) &&
          !PhoneNumberValidator.methods.ValidateSLOFixNumber(redirectElement.number)) {
        return 'invalid-phone-number'
      } else {
        return ''
      }
    }
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== null) {
        this.GetPreusmeritve()
      }
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/Preusmeritve.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/PreusmeritevMobilnaTelefonija.vue